module.exports = __webpack_public_path__ + "static/media/feetype_root.376b49e79135347eebca9e5f4ad3f6d3.png";